'use strict';

/* jshint -W098 */
angular.module('mean.trades').controller('TradesController', ['$scope', 'Global', 'Trades',
  function($scope, Global, Trades) {
    $scope.global = Global;
    $scope.package = {
      name: 'trades'
    };
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/trades/public/controllers/trades.js